module.exports = __webpack_public_path__ + "img/CtrlRoom_sleep_off.9875aac1.png";